export default __webpack_public_path__ + "static/media/flayer7.a8b183b7.jpg";